import 'uni-pages';import 'uni-h5';
import Vue from 'vue'
import App from './App'
import uView from '@/uni_modules/uview-ui'
Vue.use(uView)

// 引入lodash
import _ from 'lodash'
Vue.prototype._ = _;

// 引入uniwebView
// import uniwebView from './utils/uni.webview.1.5.2.js'

import wechat from './utils/wechat.js'
Vue.prototype.$wechat = wechat;


// import Aegis from 'aegis-web-sdk';
// const aegis = new Aegis({
// 	id: 'W7JbEfavOqrEe9b5vD', // 应用ID，即上报ID
// 	uin: 'xxx', // 用户唯一 ID（可选）
// 	reportApiSpeed: true, // 接口测速
// 	reportAssetSpeed: true, // 静态资源测速
// 	spa: true // spa 应用页面跳转的时候开启 pv 计算
// })

Vue.config.productionTip = false

//引入全局配置文件
import config from '@/config/config.js'
Vue.prototype.$config = config
//引入全局变量
import s from '@/config/sj.js'
Vue.prototype.$s = s
// 引入全局列表接口
import api from '@/api/pageApi.js'
Vue.prototype.$api = api

// 压缩图片
Vue.prototype.compression = function(url, w, h) {
	if (url) {
		url = url.replace(':9000', ':9001')
	} else {
		return undefined
	}
	if (w && h) {
		url = url + '?w=' + w + '&h=' + h
	} else if (w && !h) {
		url = url + '?w=' + w
	} else if (!w && h) {
		url = url + '?h=' + h
	}
	return url
}

// 全局组件 
import bodyList from "@/components/s-body-list/s-body-list.vue";
Vue.component("body-list", bodyList);

App.mpType = 'app'

const app = new Vue({
	...App
})
app.$mount()

















